import { render, staticRenderFns } from "./SummarySection.vue?vue&type=template&id=2ae050fd"
import script from "./SummarySection.vue?vue&type=script&lang=js"
export * from "./SummarySection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports